import { Component, VERSION } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'app-healthcheck-and-info',
    imports: [],
    templateUrl: './healthcheck-and-info.component.html',
    styleUrl: './healthcheck-and-info.component.scss'
})
export class HealthcheckAndInfoComponent {
  webPackageVersion = VERSION.full;
  buildVersion = ''
  constructor(private http: HttpClient) {
    this.loadAngularJson();
  }

  loadAngularJson() {
    this.http.get('/v3/build_version').subscribe((data) => {
      if (data && data['build_version']) {
        this.buildVersion = data['build_version'];
      }
    });
  }
}
